import React from "react";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";

const BillingHeader = () => {
  return (
    <section className="billing-header">
      <Breadcrumb>
        <BreadcrumbItem>
          <a href="/">Home</a>
        </BreadcrumbItem>
        <BreadcrumbItem active>Billing</BreadcrumbItem>
      </Breadcrumb>
      <h2 className="heading">Billing & Team Plan</h2>
      <p className="info">
        Discover team activities to bond, learn, and grow as a team.
      </p>
    </section>
  );
};

export default BillingHeader;
